const DiscountIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M1.5,24c-.384,0-.768-.146-1.061-.439-.586-.586-.586-1.535,0-2.121L21.439,.439c.586-.586,1.535-.586,2.121,0,.586,.585,.586,1.536,0,2.121L2.561,23.561c-.293,.293-.677,.439-1.061,.439ZM9,4.5C9,2.019,6.981,0,4.5,0S0,2.019,0,4.5s2.019,4.5,4.5,4.5,4.5-2.019,4.5-4.5Zm-3,0c0,.827-.673,1.5-1.5,1.5s-1.5-.673-1.5-1.5,.673-1.5,1.5-1.5,1.5,.673,1.5,1.5Zm18,15c0-2.481-2.019-4.5-4.5-4.5s-4.5,2.019-4.5,4.5,2.019,4.5,4.5,4.5,4.5-2.019,4.5-4.5Zm-3,0c0,.827-.673,1.5-1.5,1.5s-1.5-.673-1.5-1.5,.673-1.5,1.5-1.5,1.5,.673,1.5,1.5Z" />
  </svg>
);

export default DiscountIcon;
